/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type StorefrontHome_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"StorefrontFeaturedSection_viewer">;
    readonly " $refType": "StorefrontHome_viewer";
};
export type StorefrontHome_viewer$data = StorefrontHome_viewer;
export type StorefrontHome_viewer$key = {
    readonly " $data"?: StorefrontHome_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontHome_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontHome_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StorefrontFeaturedSection_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = 'e604d626df963f5912fa6bbad941e3b7';
export default node;
